/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshotBatchResponse {
    getFixupPrototypeFunction() { return TagPostureSnapshotBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshotBatchResponse>): TagPostureSnapshotBatchResponse {
        let obj = Object.assign(new TagPostureSnapshotBatchResponse(), model);
        TagPostureSnapshotBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshotBatchResponse>): TagPostureSnapshotBatchResponse {
        if (!model) return null;
        return TagPostureSnapshotBatchResponse.newInstance(<TagPostureSnapshotBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshotBatchResponse) {
        if (!obj) return;

        models.TagPostureSnapshotBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshotBatchResponse): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshotBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagPostureSnapshot.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagPostureSnapshot; };

}
